import styled from "@emotion/styled";
import { css } from "@emotion/react";

const DEFAULT_FADE_SIZE = 28;

export const ScrollFadeContainer = styled.div<{
	scrollAtTop?: boolean;
	scrollAtBottom?: boolean;
	fadeSize?: number;
}>`
	${({ scrollAtTop, scrollAtBottom, fadeSize = DEFAULT_FADE_SIZE }) => css`
		display: grid;
		overflow: auto;

		&::before,
		&::after {
			content: "";
			position: sticky;
			display: block;
			height: ${fadeSize}px;
			pointer-events: none;
			transition: opacity 0.2s;
		}

		&::before {
			top: 0;
			margin-bottom: -${fadeSize}px;
			background: linear-gradient(to top, transparent, #f1f1f1);
		}

		&::after {
			bottom: 0;
			margin-top: -${fadeSize}px;
			background: linear-gradient(to bottom, transparent, #f1f1f1);
		}

		${scrollAtTop &&
		css`
			&::before {
				opacity: 0;
			}
		`}

		${scrollAtBottom &&
		css`
			&::after {
				opacity: 0;
			}
		`}
	`}
`;
